import { Component } from '@angular/core';
import { environment } from '@env/environment.local';

@Component({
    selector: 'pexels-empty-state',
    templateUrl: 'pexels-empty-state.component.html',
    styleUrls: ['pexels-empty-state.component.scss'],
})
export class PexelsEmptyStateComponent {
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
}
